//import {format} from 'date-fns';
import { ColumnFilter } from './ColumnFilter';



function dateFormat(value){
	let objectDate = new Date(value);
	let day = ("0" + (objectDate.getDate() + 1)).slice(-2);
	let month = ("0" + (objectDate.getMonth() + 1)).slice(-2);
	let year = objectDate.getFullYear();
	
	return  day + "/" + month + "/" + year;	 
	
}


   

export const COLUMNS = [
	{
		Header : 'OrderID',
		Footer : 'OrderID',
		accessor: 'OrderID',
		Filter: ColumnFilter,
		//isVisible:"false"
		//disableFilters: true,

	},
	{
		Header : 'صاحب المعاملة',
		Footer : 'Last Name',
		accessor: 'ForpOrc',
		Filter: ColumnFilter,
	},
	
	{
		Header : 'نوع المعاملة',
		Footer : 'TransactionType',
		accessor: 'TransactionType',
		Filter: ColumnFilter,
	},
	
	{
		Header : 'القيمة المسحوبة',
		Footer : 'Country',
		accessor: 'AlsafiAmount',
		Filter: ColumnFilter,
	},
	{
		Header : 'تاريخ السحب',
		Footer : 'Country',
		accessor: 'WithdrawDate',
		Filter: ColumnFilter,
	},
	{
		Header : 'القيمة المودعة',
		Footer : 'Country',
		accessor: 'DepositAmount',
		Filter: ColumnFilter,
	},

	{
		Header : 'تاريخ الايداع',
		Footer : 'Country',
		accessor: 'DepoditDate',
		Filter: ColumnFilter,
	},
	{
		Header : 'الحالة',
		Footer : 'Country',
		accessor: 'Status',
		Filter: ColumnFilter,
	},
	
	 
	
]

export const GROUPED_COLUMNS = [
	{
		Header : 'Id',
		Footer : 'Id',
		accessor: 'id'
	},
	{
		Header : 'Name',
		Footer : 'Name',
		columns: [
			{
				Header : 'First Name',
				Footer : 'First Name',
				accessor: 'first_name'
			},
			{
				Header : 'Last Name',
				Footer : 'Last Name',
				accessor: 'last_name'
			},
		]
	},
	{
		Header: 'Info',
		Footer: 'Info',
		columns: [
			{
				Header : 'Date of  Birth',
				Footer : 'Date of  Birth',
				accessor: 'date_of_birth'
			},
			{
				Header : 'Country',
				Footer : 'Country',
				accessor: 'country',
			},
			{
				Header : 'Phone',
				Footer : 'Phone',
				accessor: 'phone'
			},
		]
	},
]